
import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

import {CONFIRM} from './constants';

import type {ConfirmTypes} from './constants';

const DATA = {
    [CONFIRM.DATES]: {
        caption: 'Unsaved changes',
        content: 'Collapsing this section will discard all unsaved changes made to this contract. Do you want to proceed anyway?',
    },
    [CONFIRM.CREDITS]: {
        caption: 'Unsaved changes',
        content: 'The Change Credits form was not saved. Collapsing it will discard its changes. Do you want to proceed anyway?',
    },
};

type Props = {
    confirmType: ConfirmTypes | null,
    onClose: () => void,
    onConfirm: () => void,
};

const MODAL_WIDTH = 400;

export const ConfirmationModal = (props: Props) => {
    const {confirmType, onClose, onConfirm} = props;

    const data = confirmType && DATA[confirmType];

    return data ? (
        <Dialog shown={true} setShown={onClose} wrapperProps={{style: {width: MODAL_WIDTH}}}>
            <DialogHeader onClose={onClose}>
                {data.caption}
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {data.content}
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button variant="Type.PRIMARY" onClick={onConfirm}>Yes</Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>Cancel</Button>
                </Group>
            </DialogFooter>
        </Dialog>
    ) : null;
};
